import DashboardPage from 'organization/theme/DashboardPage'
import {Header} from 'organization/theme/Header'
import React from 'react'

export default function OrganizationPage(props: {
  children: React.ReactElement
  modals?: React.ReactElement
}) {
  return (
    <>
      <DashboardPage modals={props.modals} header={<Header />}>
        {props.children}
      </DashboardPage>
    </>
  )
}
